import {
  LICENSE_PRO_REQUEST_REQUEST,
  LICENSE_PRO_REQUEST_SUCCESS,
  LICENSE_PRO_REQUEST_FAILURE,
  LICENSE_PRO_REQUEST_RESET,
} from '../actions/license'

const INITIAL_STATE = {
  loading: false,
  sent: false,
  error: null,
}

const licenseReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LICENSE_PRO_REQUEST_REQUEST:
      return { ...state, loading: true, sent: false, error: null }
    case LICENSE_PRO_REQUEST_SUCCESS:
      return { ...state, loading: false, sent: true, error: null }
    case LICENSE_PRO_REQUEST_FAILURE:
      return { ...state, loading: false, sent: false, error: action.error }
    case LICENSE_PRO_REQUEST_RESET:
      return INITIAL_STATE
    default:
      return state
  }
}

export default licenseReducer
